import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { SubWebsocketMessageRequest } from '@qtek/core/websockets-core';
import { TableTask, Task, TaskPayload } from '@qtek/shared/models';

export const TasksActions = createActionGroup({
  source: 'Tasks',
  events: {
    'Subscribe Tasks': props<{
      payload?: Omit<SubWebsocketMessageRequest, 'ent' | 'op'>;
      mysid: string;
    }>(),
    'Unsubscribe Tasks': props<{
      mysid: string;
    }>(),
    'Load Tasks Success': props<{
      tasks: (Task | TableTask)[];
      mysid: string;
    }>(),
    'Load Tasks Failure': props<{ error: Error; mysid: string }>(),
    'Create Task': props<{
      payload: TaskPayload;
      mysid: string;
    }>(),
    'Create Task Success': props<{
      task: Task | TableTask;
      mysid: string;
    }>(),
    'Create Task Failure': props<{ error: Error; mysid: string }>(),
    'Update Task': props<{
      payload: TaskPayload;
      mysid: string;
      id: string;
    }>(),
    'Update Task Success': props<{
      task: Task | TableTask;
      mysid: string;
    }>(),
    'Update Task Failure': props<{ error: Error }>(),
    'Delete Tasks': props<{
      taskIds: string[];
      mysid: string;
    }>(),
    'Delete Task Success': props<{
      task: Task | TableTask;
      mysid: string;
    }>(),
    'Delete Task Failure': props<{ error: Error }>(),
    'Load Tasks Meta Success': props<{
      meta: any;
      mysid: string;
    }>(),
    'Load Tasks Meta Failure': props<{ error: Error }>(),
    'Subscribe Single Task': props<{
      taskId: string;
    }>(),
    'Unsubscribe Single Task': emptyProps(),
    'Load Single Task Success': props<{
      task: Task | TableTask;
    }>(),
    'Load Single Task Failure': props<{
      error: Error;
    }>(),
    'Get Deals For Task': emptyProps(),
    'Get Deals For Task Success': props<{
      deals: { id: string; name: string }[];
    }>(),
    'Get Deals For Task Failure': props<{
      error: Error;
    }>(),
  },
});
